
const endpoints = {
  login: {
    profile: "/profileV2",
    policy: "/policy",
    adminProfile: "/profile/admin-status",
  },
  citizenship: {
    apply: {
      getEmployeeDetails: "/citizenship-reimbursements/employee-details",
      saveEmployeeDetails: "/citizenship-reimbursements/employee-details",
      submitFeeSummary: "/citizenship-reimbursement",
    },
    viewDocuments: {
      applicationsList: "/citizenship-reimbursements/applications",
      documentsList: (applicationId: string) =>
        `/citizenship-reimbursements/applications/${applicationId}/documents`,
      uploadDocument: (applicationId: string) =>
        `/citizenship-reimbursements/applications/${applicationId}/documents`,
      downloadDocument: (applicationId: string, documentId: string) =>
        `/citizenship-reimbursements/applications/${applicationId}/documents/${documentId}`,
      applicationDetails: (applicationId: string) =>
        `/citizenship-reimbursements/applications/${applicationId}/application-details`,
      managerInformation: (applicationId: string) =>
        `/citizenship-reimbursements/applications/${applicationId}/manager`,
      updateManagerDetails: "/citizenship-reimbursements/manager-details",
      searchManager: "/citizenship-reimbursements/manager/nuid",
    },
    managerPortal: {
      managerApplicationsList:
        "/citizenship-reimbursements/applications/manager",
      managerPaidTimeOff: (applicationId: string) =>
        `/citizenship-reimbursements/applications/${applicationId}/manager/time-off-details`,
    },
    admin: {
      getStatus: "/admin/status",
      getApplications: "/admin/citizenship/applications",
      getDocumentsList: (applicationId: string) =>
        `/admin/citizenship/applications/${applicationId}/documents`,
      getApplicationDetails: (applicationId: string) =>
        `/admin/citizenship/applications/${applicationId}/application-details`,
      updateApplicationStatus: "/admin/citizenship/applications/status",
      downloadDocument: (applicationId: string, documentId: string) =>
        `/admin/citizenship/applications/${applicationId}/documents/${documentId}`,
      reimbursements: (applicationId: string) =>
        `/admin/citizenship/${applicationId}/reimbursements`,
    },
  },
  tuition: {
    tuitionApply: {
      getEmployeeDetails: "/tuition-reimbursements/employee-details",
      getDropdownOptions: "/tuition-reimbursements/dropdown-options",
      getClassInfoEligibility: "/tuition-reimbursements/class-info/eligibility",
      getMileRateInfo: "/tuition-reimbursements/class-info/mile-rate",
      getCheckboxOptions: "/tuition-reimbursements/checkbox-options",
      getSchoolNameSuggestions: "/tuition-reimbursements/school-name-suggestions",
      getAdminSchoolNameSuggestions: "/admin/tuition-reimbursements/school-name-suggestions",
      saveEmployeeDetails: "/tuition-reimbursements/employee-details",
      searchAltNuid: "/tuition-reimbursements/manager/nuid",
      updatingManagerDetails: "/tuition-reimbursements/manager-details",
      submitApplicationForm: "/tuition-reimbursement",
    },
    tuitionViewDocuments: {
      getApplications: "/tuition-reimbursements/applications",
      documentsList: (applicationId: string) =>
        `/tuition-reimbursements/applications/${applicationId}/documents`,
      uploadDocument: (applicationId: string) =>
        `/tuition-reimbursements/applications/${applicationId}/documents`,
      downloadDocument: (applicationId: string, documentId: string) =>
        `/tuition-reimbursements/applications/${applicationId}/documents/${documentId}`,
      applicationDetails: (applicationId: string) =>
        `/tuition-reimbursements/applications/${applicationId}/application-details`,
            printApplication: (applicationId: string) =>
        `/tuition-reimbursements/applications/${applicationId}/print-application`,
      printFaxCover: (applicationId: string) =>
        `/tuition-reimbursements/applications/${applicationId}/print-fax-cover`,
    },
    tuitionManagerPortal: {
      managerApplicationsList: "/tuition-reimbursements/applications/manager",
      managerOtherApplicationsList:
        "/tuition-reimbursements/applications/manager/other-applications",
      applicationAllDetals: (applicationId: string) =>
        `/tuition-reimbursements/applications/${applicationId}/application-details`,
      // PATCH endpoint to update manager decision/status for an application
      managerUpdateApplicationStatus:
        "/tuition-reimbursements/applications/manager/status",
      updateApplicationStatus:
        "/tuition-reimbursements/applications/manager/application",
    },
    employeeOverview: {
      getEmployeeBalance: "/tuition-reimbursements/employee-balance",
    },
    admin: {
      getStatusOptions: (applType?: string) => {
        const queryParam = applType ? `?applType=${applType}` : "";
        return `/admin/status${queryParam}`;
      },
      getTuitionOptions: (fieldName: string, applType: string) =>
        `/admin/tuition/options?fieldName=${fieldName}&applType=${applType}`,
      searchApplications: "/admin/tuition/applications",
      getRegions: "/admin/tuition/options?fieldName=region&applType=AT001",
      getUnions: "/admin/tuition/options?fieldName=union&applType=AT001",
      bulkStatusUpdate: "/admin/tuition/applications/bulk-update-status",
      updateFlagEE: "/admin/tuition/document/update-ee-flag",
      getDocuments: (applicationId: string) =>
        `/admin/tuition/documents/${applicationId}`,
      uploadDocument: (applicationId: string) =>
        `/admin/tuition/documents/${applicationId}`,
      downloadDocument: (applicationId: string, documentId: string) =>
        `/admin/tuition/document/${applicationId}/${documentId}`,
      patchVerify: (applicationId: string) =>
        `/admin/tuition/application/verify/${applicationId}`,
      editDocuments: (applicationId: string, documentId: string) =>
        `/admin/tuition/document/${applicationId}/${documentId}`,
      getEmails: (applicationId: string) =>
        `/admin/tuition/emails/${applicationId}`,
      getEmailDetails: (applicationId: string, commId: string) =>
        `/admin/tuition/email-details/${applicationId}/${commId}`,
      manageCannedResponse: {
        getCannedResponses: "/admin/canned-responses",
        getCannedResponseById: (id: number) => `/admin/canned-responses/${id}`,
        updateCannedResponse: (id: number) => `/admin/canned-responses/${id}`,
        createCannedResponse: "/admin/canned-responses",
        deleteCannedResponse: (id: number) => `/admin/canned-responses/${id}`,
      },
      getComments: (applicationId: string) =>
        `/admin/tuition/comments/${applicationId}`,
      saveComment: (applicationId: string) =>
        `/admin/tuition/comments/${applicationId}`,
      saveEditedComment: (applicationId: string, commentId: string) =>
        `/admin/tuition/comments/${applicationId}/${commentId}`,
      downloadAttachment: (applicationId: string, documentId: string) =>
        `/admin/tuition/attachment/${applicationId}/${documentId}`,
      allApplicationDetails: (applicationId: string) =>
        `/admin/tuition/application-details/${applicationId}`,
      updateApplicationDetails: (applicationId: string) =>
        `/admin/tuition/applications/${applicationId}`,
      getBalances: (applicationId: string) =>
        `/admin/tuition/balances/${applicationId}`,
      editBalances: (applicationId: string) =>
        `/admin/tuition/edit-balances/${applicationId}`,
      reimbursementCourses: (applicationId: string) =>
        `/admin/tuition/courses/${applicationId}`,
      reimbursementCourseDetails: (applicationId: string, courseId: string) =>
        `/admin/tuition/reimbursements/${applicationId}/${courseId}`,
      updateReimbursementDetails: (applicationId: string, courseId: string) =>
        `/admin/tuition/reimbursement/${applicationId}/${courseId}`,
      getEmployeeDetails: "/admin/employee/details",
      saveApplicantInfo: "/admin/tuition-reimbursements/employee-details",
      saveManagerInfo: "/admin/tuition-reimbursements/manager-details",
      submitApplicationDetails: "/admin/tuition-reimbursement",
      classInfoEligibility:
        "/admin/tuition-reimbursements/class-info/eligibility",
      classInfoMileRate: "/admin/tuition-reimbursements/class-info/mile-rate",
      sendEmail: "/admin/tuition/send-email",
      printApplication: (applicationId: string) =>
        `/admin/tuition/application/${applicationId}/print-application`,
      printFaxCover: (applicationId: string) =>
        `/admin/tuition/application/${applicationId}/print-fax-cover`,
    },
  },
  administerSystem:{
    uploadExcel:"/admin/administrator/upload-excel",
    getApplicationErrors: (page: number, perPage: number) =>
  `/admin/administrator/application-errors?page=${page}&per_page=${perPage}`,
    deleteOneRecord: (emplApplErrId: string) => `/admin/administrator/application-errors/${emplApplErrId}`,
    deleteAllRecords: "/admin/administrator/application-errors",
    submitCorrectedErrors: (emplApplErrId: string) => `/admin/administrator/application-errors/${emplApplErrId}`
  }
};

export default endpoints;
